import {useMutation, useSuspenseQuery} from '@tanstack/react-query';

import {clientRoutes} from "_api/client-routes";
import {toastRequestError} from "_utils/axios";
import {chatToken, endConference, findConference, npsConference, storeConference} from '_api/fetchers/Client/conferences';
import {EndConference, StoreConference} from '_types/requests/Client/conference';
import type {Conference} from "_types/models/Conference";

export function useConference(id: string) {
    const queryKey = [...clientRoutes.conference(id).show] as const;

    const swr = useSuspenseQuery({
        queryKey,
        queryFn: findConference,
    });
    const conference = swr.data;

    return {...swr, conference} as const;
}

export function useStoreConference() {
    const mutationKey = [...clientRoutes.conferences.store] as const;
    return useMutation({
        mutationKey,
        mutationFn: async (payload: StoreConference) => {
            return storeConference(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}

export function useConferenceEnd(id: Conference['id']) {
    const mutationKey = [...clientRoutes.conference(id).end] as const;
    return useMutation({
        mutationKey,
        mutationFn: async (payload: EndConference) => {
            return endConference(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}


export function useConferenceChatToken(id: Conference['id']) {
    const mutationKey = [...clientRoutes.conference(id).chatToken] as const;
    return useMutation({
        mutationKey,
        mutationFn: async () => {
            return chatToken(mutationKey);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}


export function useConferenceSituationAndNps(id: Conference['id']) {
    const mutationKey = [...clientRoutes.conference(id).nps] as const;
    return useMutation({
        mutationKey,
        mutationFn: async (payload: EndConference) => {
            return npsConference(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {

        },
        onError: err => {
            toastRequestError(err);
        },
    });
}
